import { Comment, Text, Slot, VNode } from "vue";

// Функция проверяет только наличие контента в слоте. Если там что то есть она вернет true значение.
// Что бы спрятать элетент в слоте нужно ставить условие на отображение template а не на контент внутри template

//  ПРАВИЛЬНО
// <template v-if="условие" #название-слота >
//   <КОНТЕНТ/>
// </template>

//  !НЕ ПРАВИЛЬНО
// <template #название-слота >
//   <КОНТЕНТ v-if="условие" />
// </template>

export const hasSlotContent = (
  slot: Slot | undefined,
  slotProps = {}
): boolean => {
  if (!slot) {
    return false;
  }

  return slot(slotProps).some((vnode: VNode) => {
    if (vnode.type === Comment) {
      return false;
    }

    if (Array.isArray(vnode.children) && !vnode.children.length) {
      return false;
    }

    return (
      vnode.type !== Text ||
      (typeof vnode.children === "string" && vnode.children.trim() !== "")
    );
  });
};
